export default __webpack_public_path__ + "static/media/maybach.3619278f.svg";